import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
/**
 * Representa el modal de confirmación
 *
 * #class ModalConfirmComponent
 * @component
 */

@Component({
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss']
})
export class ModalConfirmComponent implements OnInit {
  /**
   * @property stateConfirm - Estado de la confirmación
   */
  public stateConfirm: string;
  /**
   * @property content - ContentId del modal de confirmación
   */
  public content: string;

  /**
   * Crea la interfaz modal de confirmación
   * #constructor
   * @param bsModalRef
   */

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit(): void {
  }

  /**
   * Confirma la acción
   * @method accept
   */
  accept() {
    this.stateConfirm = 'YES';
    this.bsModalRef.hide();
  }

  /**
   * Rechaza la acción de confirmación
   * @mehtod noAccept
   */
  noAccept() {
    this.stateConfirm = 'NO';
    this.bsModalRef.hide();
  }

}
